import "./index.scss";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../../authProvider";
import SideBarMain from "./sideBarMain";

const SideBar = () => {
  const [open, setOpen] = useState(false);

const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const { currentUser } = useAuth();

  useLayoutEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (document.body.classList.contains("toggle-sidebar")) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [currentUser]);

  return (
    <aside
      id="sidebar"
      className=" sidebar d-sm-block   sidebar_img  px-0 overflow-hidden"
    >
      {isMobile && (
        <div className="col-12 py-3 d-flex justify-content-end pe-0">
          <button
            id="toggleButton"
            className="btn bg-white shadow-sm px-1"
            onClick={() => {
              const body = document.body;
              if (body.classList.contains("toggle-sidebar")) {
                setOpen(true);
              } else {
                setOpen(false);
              }
              body.classList.toggle("toggle-sidebar");
            }}
          >
            {open ? (
              <svg viewBox="0 0 100 80" width="20" height="16" fill="#667085">
                <rect width="100" height="10"></rect>
                <rect y="30" width="100" height="10"></rect>
                <rect y="60" width="100" height="10"></rect>
                <path
                  d="M10.4712 4.47206C10.7316 4.21171 10.7316 3.7896 10.4712 3.52925C10.2109 3.2689 9.78878 3.2689 9.52843 3.52925L5.52843 7.52925C5.26808 7.7896 5.26808 8.21171 5.52843 8.47205L9.52843 12.4721C9.78878 12.7324 10.2109 12.7324 10.4712 12.4721C10.7316 12.2117 10.7316 11.7896 10.4712 11.5292L6.94265 8.00065L10.4712 4.47206Z"
                  transform="rotate(180, 8, 8)"
                />
              </svg>
            ) : (
              <svg viewBox="0 0 100 80" width="20" height="16" fill="#667085">
                <rect width="100" height="10"></rect>
                <rect y="30" width="100" height="10"></rect>
                <rect y="60" width="100" height="10"></rect>
                <path
                  d="M10.4712 4.47206C10.7316 4.21171 10.7316 3.7896 10.4712 3.52925C10.2109 3.2689 9.78878 3.2689 9.52843 3.52925L5.52843 7.52925C5.26808 7.7896 5.26808 8.21171 5.52843 8.47205L9.52843 12.4721C9.78878 12.7324 10.2109 12.7324 10.4712 12.4721C10.7316 12.2117 10.7316 11.7896 10.4712 11.5292L6.94265 8.00065L10.4712 4.47206Z"
                  transform="rotate(180, 8, 8)"
                />
              </svg>
            )}
          </button>
        </div>
      )}

      {(!isMobile || open) && <SideBarMain isMobile={isMobile} />}
    </aside>
  );
};

export default SideBar;
